import { render, staticRenderFns } from "./orderStatementInfoBox.vue?vue&type=template&id=393a00bf&"
import script from "./orderStatementInfoBox.vue?vue&type=script&lang=ts&"
export * from "./orderStatementInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports